export class StringHelper
{
    public splitWords(value: string): string[]
    {
        const words = value
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            .replace(/[^a-zA-Z0-9]+/g, ' ')
            .trim()
            .toLocaleLowerCase()
            .split(/\s+/);
        return words;
    }

    public toCamelCase(value: string): string
    {
        const words = this.splitWords(value);
        const capitalisedWords = words.map((word, index) => (index == 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)));
        const pascalCase = capitalisedWords.join('');
        return pascalCase;
    }

    public toPascalCase(value: string): string
    {
        const words = this.splitWords(value);
        const capitalisedWords = words.map(i => i.charAt(0).toUpperCase() + i.slice(1));
        const pascalCase = capitalisedWords.join('');
        return pascalCase;
    }

    public toTitleCase(value: string): string
    {
        const words = this.splitWords(value);
        const capitalisedWords = words.map(i => i.charAt(0).toUpperCase() + i.slice(1));
        const pascalCase = capitalisedWords.join(' ');
        return pascalCase;
    }

    public toKebabCase(value: string): string
    {
        const words = this.splitWords(value);
        const kebabCase = words.join('-');
        return kebabCase;
    }

    public toSnakeCase(value: string): string
    {
        const words = this.splitWords(value);
        const kebabCase = words.join('_');
        return kebabCase;
    }

    public toConcatenatedLowercase(value: string): string
    {
        const words = this.splitWords(value);
        const lowercase = words.join('').toLocaleLowerCase();
        return lowercase;
    }

    public toConcatenatedUpperrcase(value: string): string
    {
        const words = this.splitWords(value);
        const uppercase = words.join('').toLocaleUpperCase();
        return uppercase;
    }

    public splitFullName(fullName: string): { firstName: string; lastName: string }
    {
        const names = this.splitWords(fullName);
        const firstName = names[0] ?? '';
        const lastName = names.slice(1).join(' ');

        return {
            firstName: firstName,
            lastName: lastName,
        };
    }

    public initials(fullName: string): string
    {
        const names = this.splitFullName(fullName);
        const initials = (names.firstName[0] ?? '') + (names.lastName[0] ?? '');
        return initials;
    }

    public generateRandomWord(minLength = 3, maxLength = 8): string
    {
        const letters = 'abcdefghijklmnopqrstuvwxyz';
        const length = Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;
        let word = '';

        for (let i = 0; i < length; i++)
        {
            word += letters.charAt(Math.floor(Math.random() * letters.length));
        }
        return word;
    }

    public generateRandomWords(numOfWords: number): string
    {
        const words: string[] = [];
        for (let i = 0; i < numOfWords; i++)
        {
            words.push(this.generateRandomWord());
        }
        return words.join(' ');
    }
}
